import { cn } from "@/lib/utils";

type BadgeColor =
    | "gray"
    | "blue"
    | "emerald"
    | "amber"
    | "rose"
    | "violet"
    | "slate";

const COLORS: Record<BadgeColor, string> = {
    gray: "bg-gray-100 text-gray-700",
    blue: "bg-blue-50 text-blue-700",
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    rose: "bg-rose-50 text-rose-700",
    violet: "bg-violet-50 text-violet-700",
    slate: "bg-slate-100 text-slate-700",
};

interface BadgeHiProps {
    children: React.ReactNode;
    color?: BadgeColor;
    className?: string;
}

export function BadgeHi({ children, color = "gray", className }: BadgeHiProps) {
    return (
        <span
            className={cn(
                "inline-flex items-center gap-1 text-[10px] font-semibold uppercase px-2 py-0.5 rounded",
                COLORS[color],
                className
            )}
        >
            {children}
        </span>
    );
}

export function LegendDot({
    color,
    label,
}: {
    color: string;
    label: string;
}) {
    return (
        <span className="inline-flex items-center gap-1.5 text-xs text-gray-600">
            <span
                className="w-2 h-2 rounded-full"
                style={{ background: color }}
            />
            {label}
        </span>
    );
}
